export function isProductionBuild(): boolean {
  return process.env.NODE_ENV === 'production';
}
